<template>
    <div class="shows" v-if="initialized" :style="`background-image: url(${showBanner})`">
        <p class="md-headline title">{{ showName }}</p>
        <p class="md-headline title">{{ seasonName }} - Episodes</p>
        <div class="show-grid">
            <div class="shows">
                <plex-card
                    v-for="show in shows" :key="show.title"
                    @click="download(show)"
                    class="plex-card"
                    :title="`Ep ${show.index}: ${show.title}`"
                    :to="$route.fullPath"
                    :bytes="show.Media[0].Part[0].size"
                    :caption="caption(show.Media[0].Part[0].file)"
                    :image="show.thumb"/>
            </div>
        </div>
    </div>
</template>

<script>
import ServerApi from "@/js/ServerApi";
import PlexCard from "../components/PlexCard";
import Utils from "../js/Utils";

console.log(ServerApi);

export default {
    props: {
        initialized: Boolean,
    },
    name: 'shows',
    components: {PlexCard},
    data() {
        return {
            seasonName: '',
            showName: '',
            showBanner: '',
            shows: []
        }
    },
    async mounted() {
        console.log(this.$route);
        if (this.initialized) {
            this.initialize();
        } else {
            ServerApi.addEventListener('authenticated', this.initialize);
        }
    },
    methods: {
        async download(show) {
            let file = show.Media[0].Part[0].file;
            console.log('Download', file);
            let {token} = await ServerApi.fileToken(file);
            console.log('Token', token);
            let a = document.createElement('a');
            // let win = window.open(ServerApi.fileUrl(token));
            a.href = ServerApi.fileUrl(token);
            a.setAttribute('download', file.split('/')[file.split('/').length - 1]);
            // a.setAttribute('target', '_blank');
            console.log(a);
            a.click();
        },
        caption(file) {
            let p = file.split('/');
            return p[p.length - 1];
        },
        async initialize() {
            let cacheKey = `episodesCache${this.$route.query.id}`;
            if (localStorage.getItem(cacheKey) !== null) {
                this.shows = JSON.parse(localStorage[cacheKey]);
                this.seasonName = this.shows[0].parentTitle;
                this.showName = this.shows[0].grandparentTitle;
            }

            this.shows = await ServerApi.episodes(this.$route.query.id);
            localStorage[cacheKey] = JSON.stringify(this.shows);
            console.log(this.shows);
            this.seasonName = this.shows[0].parentTitle;
            this.showName = this.shows[0].grandparentTitle;
        }
    },
    beforeDestroy() {
        ServerApi.removeEventListener('authenticated', this.initialize)
    },
    watch: {
        $route() {
            this.initialize();
        }
    }
}
</script>

<style scoped>
.shows {
    overflow: hidden !important;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.title {
    text-align: center;
}

.show-grid {
    position: relative;
    left: 5px;
    max-width: 1000px;
    display: block;
    margin: 0 auto;
}

.plex-card {
    display: inline-block;
    width: calc(100% / 2 - 10px);
    margin-right: 10px;
    margin-bottom: 20px;
}

@media (min-width: 700px) {
    .plex-card {
        width: calc(100% / 3 - 10px);
    }
}

@media (min-width: 900px) {
    .plex-card {
        width: calc(100% / 4 - 10px);
    }
}


</style>